import React, { useEffect } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import {
  FruitifyStack,
  RegistrationCard,
} from "../../../../shared-components/Containers";
import Typography from "@mui/material/Typography";
import { useTrackingAnalytics } from "../../../../hooks/useTrackingAnalytics";

export default function PaymentSuccessful({ onGoToAccounts }) {
  const navigate = useNavigate();

  const { recordMarketingEvent } = useTrackingAnalytics();

  useEffect(() => {
    recordMarketingEvent("subscribed", {}, true);
  }, []);

  // TODO: if single subject plan need to ask them to select a subject? Perhaps on dashboard if no subject?
  return (
    <FruitifyStack>
      <RegistrationCard variant={"outlined"}>
        <Stack direction={"column"} alignItems={"center"} textAlign={"center"}>
          <CheckCircleOutlineIcon sx={{ fontSize: 120 }} />
          <Typography
            component="h1"
            variant="h4"
            sx={{ width: "100%", fontSize: "clamp(2rem, 10vw, 2.15rem)" }}
          >
            Success
          </Typography>
        </Stack>

        <Typography variant="body1" sx={{ width: "100%" }}>
          Thank you, your payment is complete.
        </Typography>
        <Button variant={"contained"} onClick={() => navigate("/")}>
          Dashboard
        </Button>
        <Button variant={"outlined"} onClick={onGoToAccounts}>
          Manage Account
        </Button>
      </RegistrationCard>
    </FruitifyStack>
  );
}
